/**
     * @desc 查询未上架NFT作品列表
用于查询用户未上架的NFT列表，包括未铸造的，collectionId选填
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/item/getNotOnSaleItemList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/item/getNotOnSaleItemList', params);
}
